/*
  FoxGlow card popups (phones only)
  On a phone the message box and photo upload sit far below the card preview, so
  customers had to scroll to find them. This brings them to the customer instead:
  - Choosing an option that needs a photo opens the photo picker right away
    (then the cropper from fg-card-tools.js).
  - Choosing an option that needs a message opens a popup with a text box.
    Confirm puts the message on the card preview.
  - Options with two steps (photo and text, two photos) go straight to the next one.
  - Buttons under the preview add or change the message or photo later.
  - Tapping Add to cart with something missing opens the right popup.
  Works with snippets/fg-card-customizer.liquid and assets/fg-card-tools.js.
  Wider screens keep the normal fields.
*/
(function () {
  'use strict';
  if (window.fgCardPopup) return;
  window.fgCardPopup = true;

  var phone = window.matchMedia('(max-width: 767px)');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FORM_SEL = 'form[action*="/cart/add"]:not([id*="installment"])';
  var BUY_SEL = 'button[type="submit"],button[name="add"],input[type="submit"],.shopify-payment-button,shopify-accelerated-checkout';

  // Same field map as fg-card-tools.js.
  var SIDES = {
    text:        { front: { text: 'properties[Custom Text]' }, back: null },
    image:       { front: { photo: 'properties[Uploaded Image]' }, back: null },
    photoText:   { front: { photo: 'properties[Uploaded Image]' }, back: { text: 'properties[Custom Text]' } },
    dual:        { front: { photo: 'properties[Custom Image 1]' }, back: { photo: 'properties[Custom Image 2]' } },
    legacyText:  { front: { fixed: true }, back: { text: 'properties[Back Text]' } },
    legacyImage: { front: { fixed: true }, back: { photo: 'properties[Back Image]' } }
  };

  /* ---------- Helpers ---------- */
  function modeFor(t) {
    t = (t || '').toLowerCase();
    if (t.indexOf('text only') > -1) return 'text';
    if (t.indexOf('photo and text') > -1) return 'photoText';
    if (t.indexOf('dual sided') > -1) return 'dual';
    if (t.indexOf('image only') > -1) return 'image';
    if (t.indexOf('text') > -1) return 'legacyText';
    if (t.indexOf('image') > -1) return 'legacyImage';
    return '';
  }
  function formFor(box) {
    var el = box.parentElement;
    while (el && !el.querySelector(FORM_SEL)) el = el.parentElement;
    return el ? el.querySelector(FORM_SEL) : null;
  }
  function vidOf(form) { var i = form && form.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
  function variantsOf(box) {
    try { return JSON.parse(box.querySelector('.ccf-variants').textContent); } catch (e) { return {}; }
  }
  function modeOf(box) { return modeFor(variantsOf(box)[vidOf(formFor(box))]); }
  function field(box, name) { return box.querySelector('[name="' + name + '"]'); }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  // The customizer that belongs to the same product as this element.
  function boxNear(node) {
    var e = node;
    while (e && e !== document.documentElement) {
      var b = e.querySelector && e.querySelector('.card-custom-fields');
      if (b) return b;
      e = e.parentElement;
    }
    return null;
  }

  // The things the customer adds for an option, in order (photo before text).
  function stepsFor(mode) {
    var cfg = SIDES[mode], out = [];
    if (!cfg) return out;
    var twoPhotos = !!(cfg.front && cfg.back && cfg.front.photo && cfg.back.photo);
    ['front', 'back'].forEach(function (side) {
      var s = cfg[side];
      if (!s || s.fixed) return;
      if (s.photo) out.push({ kind: 'photo', name: s.photo, side: side, word: twoPhotos || cfg.front.fixed ? side + ' ' : '' });
      if (s.text) out.push({ kind: 'text', name: s.text, side: side, word: side === 'back' ? 'back ' : '' });
    });
    return out;
  }
  function filled(box, step) {
    var f = field(box, step.name);
    if (!f) return true;
    if (step.kind === 'text') return !!f.value.trim();
    return !!(f.files && f.files.length);
  }
  function missingSteps(box, mode) {
    return stepsFor(mode).filter(function (s) { return !filled(box, s); });
  }

  /* ---------- Photo picker ---------- */
  // Must run inside a tap, or the phone won't open the picker.
  function pickPhoto(box, step) {
    var input = field(box, step.name);
    if (!input) return;
    var group = input.closest('.ccf-group');
    if (group) group.style.display = 'block';
    input.disabled = false;
    var form = formFor(box), fid = form && form.getAttribute('id');
    if (fid) input.setAttribute('form', fid);
    input.click();
  }

  /* ---------- Popup (message box, or a prompt for the next photo) ---------- */
  var P = null;

  function buildPopup() {
    var root = el('div', 'fg-crop fg-tp');
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'fg-tp-title');
    root.innerHTML =
      '<div class="fg-crop__panel fg-tp__panel">' +
        '<div class="fg-crop__head"><h2 id="fg-tp-title" class="fg-crop__title"></h2>' +
        '<button type="button" class="fg-crop__x" aria-label="Close">&times;</button></div>' +
        '<p class="fg-tp__sub"></p>' +
        '<div class="fg-tp__field">' +
          '<textarea class="fg-tp__input" rows="6" aria-labelledby="fg-tp-title"></textarea>' +
          '<div class="fg-count" aria-live="polite"><span class="fg-count__n">0</span> / <span class="fg-tp__max">400</span></div>' +
        '</div>' +
        '<div class="fg-crop__actions">' +
          '<button type="button" class="fg-crop__cancel"></button>' +
          '<button type="button" class="btn fg-crop__ok"></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    P = {
      root: root,
      title: root.querySelector('.fg-crop__title'),
      sub: root.querySelector('.fg-tp__sub'),
      input: root.querySelector('.fg-tp__input'),
      count: root.querySelector('.fg-count'),
      n: root.querySelector('.fg-count__n'),
      max: root.querySelector('.fg-tp__max'),
      cancel: root.querySelector('.fg-crop__cancel'),
      ok: root.querySelector('.fg-crop__ok')
    };
    P.input.addEventListener('input', updateCount);
    root.querySelector('.fg-crop__x').addEventListener('click', cancelPopup);
    P.cancel.addEventListener('click', cancelPopup);
    P.ok.addEventListener('click', confirmPopup);
    root.addEventListener('click', function (e) { if (e.target === root) cancelPopup(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cancelPopup(); }
    });
  }
  function updateCount() {
    var max = P.input.maxLength > 0 ? P.input.maxLength : 0;
    var n = P.input.value.length;
    P.n.textContent = n;
    P.count.classList.toggle('is-near', !!max && n >= max * 0.9);
  }
  function showPopup() {
    P.returnFocus = document.activeElement;
    P.root.hidden = false;
    document.documentElement.classList.add('fg-crop-open');
  }
  function closePopup() {
    P.root.hidden = true;
    if (!document.querySelector('.fg-crop:not([hidden])')) document.documentElement.classList.remove('fg-crop-open');
    var back = P.returnFocus;
    P.job = null;
    if (back && back.focus && document.contains(back)) back.focus({ preventScroll: true });
  }

  // A popup with a text box for the card message.
  function openText(box, step, note) {
    var ta = field(box, step.name);
    if (!ta) return;
    if (!P) buildPopup();
    var has = !!ta.value.trim();
    P.job = { kind: 'text', box: box, step: step, ta: ta };
    P.root.classList.remove('is-step');
    P.title.textContent = note ? note.title
      : step.side === 'back' ? (has ? 'Edit the message for the back' : 'Add a message for the back')
      : (has ? 'Edit your message' : 'Add your message');
    P.sub.textContent = note ? note.text : 'Type it below and tap Confirm. It will show on the card preview.';
    var max = ta.maxLength > 0 ? ta.maxLength : 400;
    P.input.maxLength = max;
    P.max.textContent = max;
    P.input.placeholder = ta.getAttribute('placeholder') || 'Type your message...';
    P.input.value = ta.value;
    updateCount();
    P.cancel.textContent = 'Cancel';
    P.ok.textContent = 'Confirm';
    showPopup();
    P.input.focus({ preventScroll: true });
    try { P.input.setSelectionRange(P.input.value.length, P.input.value.length); } catch (e) {}
  }

  // A prompt for the next photo (the phone only opens the picker from a tap).
  function openPhotoPrompt(box, step, note) {
    if (!P) buildPopup();
    P.job = { kind: 'photo', box: box, step: step };
    P.root.classList.add('is-step');
    P.title.textContent = note ? note.title : 'Now add your ' + step.word + 'photo';
    P.sub.textContent = note ? note.text
      : step.side === 'back' ? 'This photo goes on the back of the card.' : 'Choose the photo for your card.';
    P.cancel.textContent = 'Later';
    P.ok.textContent = 'Choose photo';
    showPopup();
    P.ok.focus({ preventScroll: true });
  }

  function cancelPopup() {
    if (!P || !P.job) return;
    P.job.box._fgFlow = null;
    closePopup();
  }
  function confirmPopup() {
    var job = P && P.job;
    if (!job) return;
    var box = job.box;
    if (job.kind === 'photo') {
      closePopup();
      pickPhoto(box, job.step); // still inside the tap
      return;
    }
    var ta = job.ta;
    ta.value = P.input.value;
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.dispatchEvent(new Event('change', { bubbles: true }));
    closePopup();
    var flow = box._fgFlow;
    if (flow && flow.queue.length && flow.queue[0].name === job.step.name) {
      flow.queue.shift();
      if (nextStep(box)) return;
    }
    schedule();
    setTimeout(function () { revealPreview(box); }, 300);
  }

  /* ---------- Step-by-step flow after choosing an option ---------- */
  function runStep(box, step, inTap) {
    if (step.kind === 'text') openText(box, step);
    else if (inTap) pickPhoto(box, step);
    else openPhotoPrompt(box, step);
  }
  // Go on to the next missing item, if any. Returns true when something opened.
  function nextStep(box) {
    var flow = box._fgFlow;
    if (!flow) return false;
    while (flow.queue.length && filled(box, flow.queue[0])) flow.queue.shift();
    if (!flow.queue.length) { box._fgFlow = null; return false; }
    var step = flow.queue[0];
    setTimeout(function () { runStep(box, step, false); }, 250);
    return true;
  }
  function revealPreview(box) {
    var stage = box.querySelector('.fg-stage');
    if (!stage || !visible(stage)) return;
    var r = stage.getBoundingClientRect();
    if (r.top < 70 || r.bottom > window.innerHeight - 20) {
      stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  }

  // Choosing an option: open what it needs right away.
  function startFor(t) {
    if (P && P.job) return false;
    var box = boxNear(t);
    if (!box || !box.querySelector('.fg-preview')) return false;
    var mode = modeFor(t.value);
    if (!SIDES[mode]) return false;
    var missing = missingSteps(box, mode);
    box._fgFlow = missing.length ? { queue: missing.slice() } : null;
    if (missing.length) { runStep(box, missing[0], true); return true; }
    setTimeout(function () { revealPreview(box); }, 300);
    return false;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!phone.matches || !t.matches || !t.matches('[data-product-options] input[type="radio"], [data-product-options] select')) return;
    startFor(t);
  }, true);
  // Tapping the option that is already chosen (no change event) works the same way.
  document.addEventListener('click', function (e) {
    if (!phone.matches) return;
    var label = e.target.closest && e.target.closest('[data-product-options] label');
    if (!label) return;
    var radio = label.htmlFor ? document.getElementById(label.htmlFor) : label.querySelector('input[type="radio"]');
    if (!radio || radio.type !== 'radio' || !radio.checked) return;
    // Keep the tap from moving focus back to the option, so the text box keeps it.
    if (startFor(radio)) e.preventDefault();
  }, true);

  // A cropped photo was confirmed (fg-card-tools.js holds back the raw file until then).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.card-custom-fields input[type="file"]')) return;
    if (!input.files || !input.files.length) return;
    var box = input.closest('.card-custom-fields');
    if (!box || !phone.matches) return;
    var flow = box._fgFlow;
    if (flow && flow.queue.length && flow.queue[0].name === input.name) {
      flow.queue.shift();
      if (nextStep(box)) return;
    }
    setTimeout(function () { revealPreview(box); }, 350);
  });

  // Add to cart with something missing: open the right popup instead of a hidden field.
  window.addEventListener('click', function (e) {
    if (!phone.matches) return;
    var t = e.target;
    var btn = t && t.closest && t.closest(BUY_SEL);
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form) return;
    var box = null;
    document.querySelectorAll('.card-custom-fields').forEach(function (b) {
      if (!box && visible(b) && b.querySelector('.fg-preview') && formFor(b) === form) box = b;
    });
    if (!box) return;
    var missing = missingSteps(box, modeOf(box));
    if (!missing.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    box._fgFlow = { queue: missing.slice() };
    var step = missing[0];
    if (step.kind === 'text') {
      openText(box, step, {
        title: step.side === 'back' ? 'Add a message for the back first' : 'Add your message first',
        text: 'Type it below and tap Confirm, then add the card to your cart.'
      });
    } else {
      openPhotoPrompt(box, step, {
        title: 'Add your ' + step.word + 'photo first',
        text: 'Choose a photo for your card, then add it to your cart.'
      });
    }
  }, true);

  /* ---------- Buttons under the preview ---------- */
  var ICON_TEXT = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M13.6 3.4l3 3L7 16H4v-3l9.6-9.6z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var ICON_PHOTO = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><rect x="2.5" y="4" width="15" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="7.5" cy="8.5" r="1.5" fill="currentColor"/><path d="M4 15l4.5-4.5 3 3 2-2L17 15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  function refresh(box) {
    var preview = box.querySelector('.fg-preview');
    if (!preview) return;
    var on = phone.matches;
    box.classList.toggle('fg-pop', on);
    var bar = preview.querySelector('.fg-edit');
    if (!bar) {
      bar = el('div', 'fg-edit');
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'Add to your card');
      var stage = preview.querySelector('.fg-stage');
      if (stage) stage.insertAdjacentElement('afterend', bar); else preview.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-act]');
        if (!b) return;
        var mode = modeOf(box);
        var step = stepsFor(mode).filter(function (s) { return s.name === b.getAttribute('data-name'); })[0];
        if (!step) return;
        box._fgFlow = null;
        if (b.getAttribute('data-act') === 'adjust') {
          var input = field(box, step.name);
          if (input && input._fgAdjust) input._fgAdjust.click();
        } else if (step.kind === 'text') {
          openText(box, step);
        } else {
          pickPhoto(box, step);
        }
      });
    }
    var steps = on ? stepsFor(modeOf(box)) : [];
    var items = [];
    steps.forEach(function (s) {
      var has = filled(box, s);
      var label = s.kind === 'text'
        ? (has ? 'Edit ' + s.word + 'message' : (s.side === 'back' ? 'Add a message for the back' : 'Add your message'))
        : (has ? 'Change ' : 'Add ') + s.word + 'photo';
      items.push({ act: 'edit', name: s.name, kind: s.kind, label: label, primary: !has });
      var input = s.kind === 'photo' && field(box, s.name);
      if (input && input._fgSaved && input._fgAdjust) {
        items.push({ act: 'adjust', name: s.name, kind: 'photo', label: 'Adjust ' + (s.word ? s.word.trim() : 'photo'), small: true });
      }
    });
    var errs = [];
    if (on) box.querySelectorAll('.ccf-group .fg-err').forEach(function (p) { if (p.textContent) errs.push(p.textContent); });
    var key = JSON.stringify([items, errs]);
    if (bar._fgKey === key) return;
    bar._fgKey = key;
    bar.innerHTML = '';
    items.forEach(function (it) {
      var b = el('button', 'fg-edit__btn' + (it.primary ? ' is-primary' : '') + (it.small ? ' is-small' : ''));
      b.type = 'button';
      b.setAttribute('data-act', it.act);
      b.setAttribute('data-name', it.name);
      b.innerHTML = it.small ? '' : (it.kind === 'text' ? ICON_TEXT : ICON_PHOTO);
      b.appendChild(el('span', '', it.label));
      bar.appendChild(b);
    });
    errs.forEach(function (msg) {
      var p = el('p', 'fg-edit__err', msg);
      p.setAttribute('role', 'alert');
      bar.appendChild(p);
    });
    bar.hidden = !items.length && !errs.length;
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll('.card-custom-fields').forEach(refresh);
    }, 200);
  }
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('click', schedule);
  if (phone.addEventListener) phone.addEventListener('change', schedule);
  else if (phone.addListener) phone.addListener(schedule);
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length || list[i].removedNodes.length) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
